export const LOAD_MEDICATIONS = "medications/LOAD_MEDICATIONS";
export const UNLOAD_MEDICATIONS = "medications/UNLOAD_MEDICATIONS";
